import { upperCaseFirst } from './misc';

export const generateActions = ({ keys, service }) => {
  const actions = {};

  keys.forEach(key => {
    const name = upperCaseFirst(key);
    const getName = `get${name}`;
    const setName = `set${name}`;

    actions[getName] = async ({ commit }) => {
      const data = await service[getName]();
      commit(setName, data);
    };
  });

  return actions;
};

export const generateActionsNames = keys => keys.map(key => `get${upperCaseFirst(key)}`);

export const generateMutations = keys => {
  const mutations = {};

  keys.forEach(key => {
    const name = `set${upperCaseFirst(key)}`;

    mutations[name] = (state, payload) => {
      state[key] = payload;
    };
  });

  return mutations;
};

export const generateGetters = keys => {
  const getters = {};

  keys.forEach(key => {
    getters[key] = state => state[key];
  });

  return getters;
};

export const generateEmptyCollections = keys => {
  const collections = {};

  keys.forEach(key => {
    collections[key] = [];
  });

  return collections;
};
